// Indonesian language file
export const ID = {
  preparing_zip: "Menyiapkan zip…",
  compressing: "Mengompresi…",
  info_icon: "Setelah ditandai sebagai selesai, tidak ada anggota tambahan yang dapat bergabung atau ditambahkan, dan semua grup obrolan akan dinonaktifkan. Harap dicatat bahwa proyek, bersama dengan semua grup obrolan dan data, akan tetap dapat diakses dalam keadaan dinonaktifkan.",
  mark_is_done: "Apakah Anda yakin ingin menandai proyek sebagai selesai? Setelah ditandai, tidak ada anggota tambahan yang dapat bergabung atau ditambahkan, dan semua grup obrolan akan dinonaktifkan. Harap dicatat bahwa proyek, bersama dengan semua grup obrolan dan data, akan tetap dapat diakses dalam keadaan dinonaktifkan.",
  mark_not_done: "Apakah Anda yakin ingin membuka kembali proyek? Setelah ditandai sebagai terbuka, anggota tambahan dapat bergabung atau ditambahkan, dan semua grup obrolan akan diaktifkan kembali.",
  mark_as_completed: "Tandai proyek sebagai selesai",
  room_completed: "Proyek selesai",
  room_members: "Anggota proyek",
  deactivated_rooms: "Proyek yang dinonaktifkan",
  deactivated_chats: "Obrolan yang dinonaktifkan",
  completed_rooms: "Proyek yang selesai",
  request_to_join_a_room: 'Permintaan untuk bergabung dengan proyek',
  wants_to_rejoin_room: 'Username ingin bergabung kembali dengan proyek Roomname.',
  invited_you_to_join_room: 'Username mengundang Anda untuk bergabung dengan proyek Roomname.',
  restart: "Mulai ulang",
  update_text: "Pembaruan baru tersedia. Klik mulai ulang untuk menginstal pembaruan.",
  update_availble: "Pembaruan tersedia",
  Loading: "Memuat...",
  logout: "Keluar",
  back: 'Kembali',
  company_list: "Daftar Perusahaan",
  followers: "Pengikut",
  followings: "Mengikuti",
  article: "Artikel",
  companies: "Perusahaan",
  one_to_one_chat: " Obrolan satu lawan satu",
  profile: "Profil",
  company: "Perusahaan",
  company_selection: "Pemilihan perusahaan",
  home: "Beranda",
  contact: "Kontak ",
  add_company: "Tambah Perusahaan ",
  add_project: "Tambah Proyek ",
  capacities: "Kapasitas ",
  work_area: "Area Kerja",
  company_services: "Layanan perusahaan",
  website: "Situs web",
  search_contacts: "Cari kontak",
  add_or_join_a_company: "Tambah atau bergabung dengan perusahaan",
  follow: "Ikuti",
  following: "Mengikuti",
  like: "Suka",
  company_contacts: "Kontak perusahaan",
  leave_the_company: "Tinggalkan perusahaan",
  news: "Berita",
  earlier: "Sebelumnya",
  action: "Tindakan",
  another_action: "Tindakan lain",
  something_else: "Lainnya",
  search: "Cari",
  search_rooms: "Cari proyek",
  search_articles: "Cari artikel",
  contacts: "Kontak",
  suggestions: "Saran",
  project_list: "Daftar proyek",
  search_results: "Hasil pencarian",
  add_or_join_project: "Tambah atau bergabung dengan proyek",
  details: "Detail",
  your_position_within_company: "Silakan pilih posisi Anda dalam perusahaan.",
  close_modal: "Tutup",
  map: "Peta",
  or: "Atau",
  name: "Nama*",
  street: "Jalan*",
  house_number: "Nomor Rumah",
  postal_code: "Kode Pos",
  city: "Kota*",
  opened_by: "Dibuka oleh:",
  project_No: "Nomor proyek: ",
  building_type: "Jenis Bangunan*",
  building_types: "Jenis Bangunan",
  add_join: "Tambah/Bergabung",
  mandatory_fiels: "*bidang wajib",
  invalid_fiels: "Bidang ini wajib diisi",
  add_or_join_company: "Tambah atau bergabung dengan perusahaan",
  name_of_the_company: "Nama perusahaan",
  edit_company_details: "Edit detail perusahaan",
  branch_of_the_building_industry: "Cabang industri konstruksi",
  corporate_form: "Bentuk perusahaan",
  position_within_company: "Posisi dalam perusahaan",
  request_confirmation: "Permintaan proyek tertunda",
  company_e_mail: "Email perusahaan",
  type_of_filter: "Ketik untuk memfilter...",
  setting: "Pengaturan",
  dashboard: "Dasbor",
  settings: "Pengaturan",
  views: "Tayangan",
  times_seen: "kali dilihat",
  see_more: "...lebih banyak",
  see_less: "...lebih sedikit",
  in_search: "dalam pencarian",
  reset_password: "Atur Ulang Kata Sandi",
  submit: "Kirim",
  password: "Kata Sandi",
  email: "Email",
  confirm_password: "Konfirmasi Kata Sandi",
  reset_email: "Atur Ulang Email",
  update: "Perbarui",
  new_email: "Email Baru",
  kjuup_message: "Pesan Kjuup",
  delete_profile: "Hapus Profil?",
  my_position: "Posisi Saya:",
  add: "tambah",
  owner_company_admin: "Admin perusahaan:",
  owner_company_admin_new: "Admin perusahaan",
  mutual_contact: "kontak bersama",
  mutual_contacts: "kontak bersama",
  co_owner: "Pemilik bersama",
  managing_director: "Direktur Utama",
  associate: "Asosiasi",
  secretary: "Sekretaris",
  employee: "Karyawan",
  project_manage: "Manajer Proyek",
  auto_chat_translation: "Terjemahan Obrolan Otomatis",
  translate_room_group_names: "Terjemahkan nama grup obrolan",
  translate_room_group_names_info: "Jika diaktifkan, nama grup obrolan diterjemahkan otomatis ke bahasa antarmuka.",
  default_view_email: "Default View: E-Mail",
  default_view_email_info: "Jika diaktifkan, tab E-Mail akan terbuka secara default alih-alih Pesan saat membuka aplikasi.",
  integrate_email_in_messages: "Integrate E-Mail in Messages",
  integrate_email_in_messages_info: "When enabled, emails from all connected accounts will appear alongside your chat messages, sorted by date.",
  language: "Bahasa",
  english: "Bahasa Inggris",
  german: "Bahasa Jerman",
  french: "Bahasa Prancis",
  italian: "Bahasa Italia",
  change_language: "Ubah Bahasa",
  my_companies: "Perusahaan Saya",
  employees: "Karyawan",
  invite_with_a: "Undang ke Kjuup",
  add_member: "Tambah Anggota",
  add_user: "Tambah Pengguna",
  send_location: "Kirim Lokasi",
  assign_admin_rights: "Sesuaikan hak admin",
  deactivate_company: "Nonaktifkan Perusahaan",
  remove_employees: "Hapus Karyawan",
  remove_members: "Hapus anggota",
  no_user_found: "Pengguna tidak ditemukan!",
  approve: "Setujui!",
  deselect_all: "Batalkan Pilihan Semua",
  select_all: "Pilih Semua",
  translation_on_building_projects: "Terjemahan di proyek",
  reported_capacities: "Layanan yang dilaporkan",
  up_to_50m_exact: "Hingga 50m Tepat",
  company_details_service: "Layanan Perusahaan",
  company_contact: "Kontak Perusahaan",
  invite_with_link: "Undang ke Kjuup",
  share_link: "Bagikan Tautan",
  share_company_link: "Bagikan tautan",
  qr_code: "Kode QR",
  copy_link: "Salin Tautan",
  cancel_link: "Batalkan Tautan",
  who_has_confirmed_services: "Siapa yang telah mengonfirmasi layanan Anda?",
  projectss: "Proyek",
  add_services: "Tambah Layanan",
  services: "Layanan",
  save_text: "Simpan",
  share_on: "Bagikan Di:",
  articlen: "Artikel",
  invite_user_to_confirm_service: "Undang pengguna untuk mengonfirmasi layanan ke perusahaan.",
  link_copied: "Tautan Disalin!",
  email_copied: "Email Disalin!",
  personal_article: "Artikel Pribadi",
  company_article: "Artikel Perusahaan",
  characters_remaining: "Karakter Tersisa",
  optional_information: "Informasi Opsional",
  project: "Proyek",
  projects: "Proyek...",
  abort: "Buang",
  preview: "Pratinjau",
  post: "Posting",
  of: "dari",
  remove: "Hapus",
  free_capacity: "Portal pekerjaan",
  current_status_overview: "Ringkasan Status Saat Ini",
  report_capacities: "Laporkan layanan",
  report_text: "Laporkan",
  search_capacities: "Temukan kontraktor",
  add_project_user: "Tambah Pengguna Proyek",
  media: "Media",
  links: "Tautan",
  docs: "Dokumen",
  featured_products: "Produk Unggulan...",
  title: "Judul",
  text: "Teks",
  feed_details: "Detail Feed",
  add_employee: "Tambah Karyawan",
  latest: "Terbaru",
  my_projects: "Proyek Saya",
  cancel: "Batal",
  continue: "Lanjutkan",
  role_in_the_building_industry: "Peran dalam Industri Konstruksi",
  als: "sebagai",
  join: "bergabung",
  find: "Temukan",
  request_to_join_a_company: "Permintaan untuk bergabung dengan perusahaan",
  wants_to_join_the_company: "ingin bergabung dengan perusahaan",
  filter_by: "Filter menurut",
  ok: "Ok",
  close: "Tutup",
  weekly_statistics: "Statistik Mingguan",
  is_following_you: "sedang mengikuti Anda.",
  as: "sebagai",
  has_joined_the: "telah bergabung dengan perusahaan",
  has_looked_at_your_profile: "telah melihat profil Anda.",
  time: "Waktu",
  in_searches_in_past_week: "dalam pencarian minggu lalu.",
  has_liked_your_article: "telah menyukai artikel Anda.",
  has_published_a_new_article: "telah menerbitkan artikel baru.",
  you: "Anda",
  all_views: "Semua Tayangan",
  all_profile_views: "Semua Tayangan Profil",
  mutual_company: "perusahaan bersama",
  artical_text: "Tulis artikel...",
  you_have_appeared: "Anda telah muncul",
  your_request_at_the_company: "Permintaan Anda di perusahaan",
  times_you_have_appeared_in_searches: "kali Anda telah muncul dalam pencarian",
  appear_more_often_in_searches: "Muncul lebih sering dalam pencarian",
  you_have_been_found: "Anda telah ditemukan",
  improve_profile: "Tingkatkan Profil",
  choose_existing_contact_for_single_chat: "Pilih kontak yang ada untuk obrolan tunggal:",
  in_order_to_add_new_contacts: "Untuk menambahkan kontak baru, silakan cari kontak baru di halaman profil.",
  times_in_searches_in_the_last_week: "kali dalam pencarian minggu lalu. Perbarui profil Anda dan tambahkan detail lebih lanjut agar lebih mudah ditemukan.",
  has_been_confirmed: "telah dikonfirmasi.",
  have_joined_the: "telah bergabung dengan ",
  building_project: " proyek konstruksi.",
  select_with_which_company_you_want_to_connect_to_the_project: "Pilih perusahaan yang akan Anda wakili. Ini akan ditampilkan kepada peserta lain.",
  select_with_which_company_you_want_to_connect_to_the_chat: "Pilih perusahaan yang akan Anda wakili. Ini akan ditampilkan kepada peserta lain.",
  select_internal_section: "Silakan pilih bagian internal",
  select_profile_image: "Pilih Gambar Profil",
  share_user: "Bagikan Pengguna",
  contact_sender_message: "Bagikan tautan ini untuk mengundang non-anggota Kjuup ke Kjuup. Tautan ini dapat digunakan oleh beberapa orang untuk mendaftar.",
  project_sender_message: "Bagikan tautan ini untuk mengundang non-anggota Kjuup ke proyek “nama proyek”. Tautan ini dapat digunakan oleh beberapa orang untuk mendaftar dan bergabung dengan proyek “nama proyek” di Kjuup.",
  company_sender_message: "Bagikan tautan ini untuk mengundang non-anggota Kjuup ke perusahaan nama perusahaan. Tautan ini dapat digunakan oleh beberapa orang untuk mendaftar dan bergabung dengan perusahaan di Kjuup.",
  contact_receivers_message: "Tautan undangan untuk bergabung dengan Kjuup. Silakan klik tautan untuk mendaftar kjuup.",
  iphone: "iPhone:",
  iphone_recivers_message: "Jika Anda menginstal Kjuup melalui Apple App Store, Anda harus mengklik tautan ini setelah unduhan berhasil, untuk dapat mendaftar.",
  project_receivers_message: "Tautan undangan untuk bergabung dengan proyek “nama proyek” di Kjuup. Silakan klik tautan untuk mendaftar Kjuup dan bergabung dengan proyek “nama proyek”.",
  company_receivers_message: "Tautan undangan ke perusahaan nama perusahaan di Kjuup. Silakan klik tautan untuk mendaftar Kjuup dan bergabung dengan perusahaan nama perusahaan.",
  sign_in: "Masuk",
  enter_your_email_add: "Masukkan alamat email Anda",
  forgot_password: "Lupa Kata Sandi",
  dont_have_account: "Tidak punya akun?",
  register: "Daftar",
  get_app: "Dapatkan aplikasi",
  registration: "Pendaftaran",
  dep_ing: "Dipl.-Ing.",
  dr: "Dr.",
  dr_ing: "Dr.-Ing.",
  dep_ing_arc: "Dipl.-Ing. Architect",
  prof: "Prof.",
  first_name: "Nama depan",
  last_name: "Nama belakang",
  have_an_account: "Sudah punya akun?",
  when_register_you_agree: "Saat mendaftar, Anda menyetujui",
  term_of_use: "ketentuan penggunaan",
  to: "kami.",
  in_our: "Dalam",
  data_policy: "kebijakan data",
  they_find_out: "mereka mengetahui,",
  we_provide_store_data: "cara kami mengumpulkan, memproses, dan menyimpan informasi.",
  leaving_company_text: "Apakah Anda benar-benar ingin meninggalkan perusahaan? Saat meninggalkan perusahaan, Anda juga meninggalkan semua proyek dan grup obrolan terkait. Anda dapat bergabung kembali dengan proyek ini dengan perusahaan lain kapan saja.",
  delete_profile_text: "Apakah Anda benar-benar ingin menghapus profil Anda? Saat Anda menghapus profil, semua koneksi ke perusahaan, proyek, dan obrolan akan dihapus. Anda dapat membuat profil baru kapan saja.",
  confirm: "Konfirmasi",
  reject: "Tolak",
  requet_to_leave: "Permintaan untuk pergi",
  choose: "Pilih",
  your_add_member: "Tambah anggota",
  if_you: "jika Anda",
  can_not_find: "tidak dapat menemukan kontak Anda di sini.",
  please_wait: "Harap tunggu..",
  imprint_gtc: "Cap/Syarat & Ketentuan",
  register_confirm_popup: "Harap verifikasi email Kjuup Anda sebelum masuk. Kami telah mengirim tautan konfirmasi. Jika tidak terlihat, periksa juga folder spam.",
  PENDING_GROUP_USER: "akan menerima pesan hanya setelah undangan ke proyek dikonfirmasi. Pesan tambahan akan muncul setelah undangan ke proyek dikonfirmasi.",
  PENDING: "Konfirmasi undangan ke proyek tertunda",
  denied_group_chat: " telah menolak undangan proyek dan telah meninggalkan grup ini.",
  joined_group_chat: " telah bergabung dengan grup ini",
  you_joined_group_chat: "Anda telah bergabung dengan grup ini.",
  Others: "Lainnya",
  LEFT_GROUP: "telah meninggalkan grup obrolan ini.",
  YOU_LEFT_GROUP: "telah meninggalkan grup obrolan ini.",
  days: "hari",
  day: "hari",
  hour: "jam",
  hide_project: "Sembunyikan proyek",
  hide_project_popup_text: "Jika Anda menyembunyikan proyek, mereka tidak dapat ditemukan dalam Kjuup. Hanya anggota proyek yang dapat mengundang pengguna baru ke proyek.",
  branch: "Cabang",
  photo_video_media_lib: "Perpustakaan media - Foto dan Video",
  document: "Dokumen",
  location_meeting: "Lokasi / Pertemuan",
  all_member_of_project: "Semua anggota proyek",
  pending_request: "Permintaan proyek tertunda",
  no_pending_request: "Tidak ada permintaan tertunda yang ditemukan!",
  news_feed: "Feed Berita",
  user_info: "Info Grup",
  leave_project: "Tinggalkan proyek",
  media_link_docs: "File",
  search_chat: "Cari Obrolan",
  export_chat_group: "Ekspor data grup obrolan dari bulan lalu",
  request_complete_chat_history: "Minta riwayat obrolan lengkap",
  leave_chat_group: "Tinggalkan grup obrolan",
  add_user_project: "Tambah Pengguna",
  me: "Saya",
  max_open_one_to_one: "Saat ini maks. 2 obrolan satu lawan satu dapat dibuka secara paralel di bagian bawah dan atas. Total maks. 4 obrolan satu lawan satu dimungkinkan.",
  are_you_sure_you_want_leave_chat: "Apakah Anda yakin ingin meninggalkan grup obrolan ini?",
  create_group: "Buat Grup",
  adding_members: "Menambahkan anggota...",
  creating_the_chat: "Membuat obrolan...",
  finishing_setup: "Menyelesaikan...",
  group_name: "Nama Grup",
  by: "Oleh:",
  mandetory: "*wajib",
  delteed: "telah menghapus profilnya dan telah meninggalkan obrolan grup.",
  deleted_direct: "telah menghapus profilnya dan telah meninggalkan obrolan.",
  unhidden_message: "Jika Anda membatalkan penyembunyian proyek, mereka dapat ditemukan oleh semua anggota Kjuup.",
  account_deleted: "Akun telah dihapus.",
  refuse_company: "Apakah Anda yakin ingin menolak undangan perusahaan?",
  follow_additional: "Ikuti pengguna tambahan",
  f_add: "Ikuti pengguna tambahan Kjuup untuk membuat mereka tersedia untuk pesan langsung.",
  c_inv: "Undangan perusahaan",
  invited_o_Company: "Anda telah diundang untuk bergabung dengan perusahaan",
  refuse_companyX: "Apakah Anda yakin ingin menolak permintaan perusahaan?",
  a_Da: "Akun dinonaktifkan.",
  has_deactivated: "telah menonaktifkan profilnya.",
  reactive: "telah mengaktifkan kembali profilnya.",
  juup_note: "*Pendaftaran dengan nama pengguna hanya tersedia untuk anggota Kjuup+",
  username: "Nama Pengguna*",
  email_username: "Email/Nama Pengguna*",
  sPinText: "Silakan berikan PIN keamanan 6 digit. PIN ini akan diperlukan jika Anda lupa kata sandi dan wajib untuk mengonfirmasi akun Anda.",
  DeleteKjuupPlusText: "Apakah Anda benar-benar ingin menghapus profil Anda? Saat Anda menghapus profil, semua koneksi ke perusahaan, proyek, dan obrolan akan dihapus.\n\nDalam 48 jam setelah penghapusan akun, Anda dapat mengaktifkan kembali akun Anda dengan masuk menggunakan nama pengguna, kata sandi, dan PIN.",
  reactive_text: "Akun Anda telah dihapus. Silakan klik Aktifkan Kembali untuk mengaktifkan kembali akun Anda.",
  rac: "Aktifkan Kembali",
  ac_ss: "Akun berhasil diaktifkan kembali.",
  not_valid_pin: "PIN tidak valid",
  only_for_kjuup: "*Pengaturan ulang kata sandi melalui nama pengguna dan PIN hanya tersedia untuk anggota Kjuup+.",
  resetPIN: "Atur Ulang PIN",
  enter_current_pin: "Silakan masukkan PIN Anda saat ini",
  enter_new: "Masukkan PIN baru",
  pin_to_confirm: "Silakan berikan PIN untuk konfirmasi.",
  change_username: "Atur Ulang Nama Pengguna",
  pp_not_match: "Kata Sandi - dan Konfirmasi Kata Sandi tidak cocok",
  reactive_itself: "Anda telah mengaktifkan kembali profil Anda.",
  has_deactivated_itself: "Anda telah menonaktifkan profil Anda.",
  more_than_two: "Saat ini pesan langsung hanya dapat dilakukan dengan 2 pengguna secara paralel.",
  Chats: "Pesan Langsung",
  only_in_mobileL: "Video asli saat ini hanya dapat diunggah dan diposting melalui Aplikasi seluler. Silakan gunakan tautan video Youtube dan Vimeo.",
  register_pin_text: "Silakan pilih PIN pribadi 6 digit Anda. PIN ini akan diperlukan untuk mengaktifkan fungsi pengaturan ulang akun.",
  internal_project: "Internal",
  external_projects: "Eksternal",
  in_deacticted: "Bagian internal dinonaktifkan.",
  create_article: "Buat Artikel",
  new_article_selection: "Buat artikel untuk Feed Berita eksternal",
  new_article_selection_internal: "Buat artikel internal",
  active_trans_title: "Aktifkan terjemahan otomatis?",
  active_trans: "Saat diaktifkan, semua pesan obrolan masuk akan diterjemahkan ke bahasa aplikasi yang Anda pilih.",
  disable_trans: "Apakah Anda benar-benar ingin menonaktifkan terjemahan otomatis?",
  allow_access_chat: "Tampilkan riwayat obrolan lengkap",
  toggle_chat_history_on: "Apakah Anda benar-benar ingin pengguna melihat riwayat obrolan lengkap?",
  toggle_chat_history_off: "Apakah Anda benar-benar ingin pengguna hanya melihat riwayat obrolan dari titik bergabung dengan obrolan?",
  check_selected_settings: "Silakan periksa pengaturan riwayat obrolan untuk semua pengguna yang dipilih!",
  chat_from_start_have: "Anda telah bergabung dengan grup ini. Riwayat obrolan telah dibagikan.",
  chat_from_start_has: "telah bergabung dengan grup ini. Riwayat obrolan telah dibagikan.",
  Address: "Alamat",
  read_by: "Dibaca oleh",
  deliver_to: "Dikirim ke",
  remaining: "tersisa",
  message_info: "Info Pesan",
  request_to_join_only: "Permintaan untuk bergabung",
  unfollow: "Berhenti Mengikuti",
  company_username: "Nama Pengguna",
  month: ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"],
  remove_my_admin_right: "Hapus hak admin saya",
  makeEmp: "Apakah Anda benar-benar ingin menghapus hak admin perusahaan dari pengguna?",
  remove_my_self: "Apakah Anda benar-benar ingin menghapus hak admin perusahaan dari akun Anda?",
  makeAdmin: "Apakah Anda benar-benar ingin memberikan hak admin perusahaan kepada pengguna?",
  remove_member: "Hapus Anggota",
  remove_following_confirm: "Apakah Anda benar-benar ingin menghapus {name} dari daftar mengikuti?",
  remove_follower_confirm: "Apakah Anda benar-benar ingin menghapus {name} dari pengikut Anda? Jika dihapus, ia tidak akan diberitahu.",
  do_you_really_want_to_remove: "Apakah Anda benar-benar ingin menghapus nama pengguna dari perusahaan?",
  invite_all: "Undang semua anggota perusahaan",
  invite_all_members: "Undang semua anggota",
  mems: "Semua anggota lainnya",
  dep_loc: "Departemen/Lokasi/Tim",
  depAdmin: "Admin Departemen",
  add_remove_admin: "Tambah/Hapus posisi admin perusahaan",
  add_remove_dep_admin: "Tambah/Hapus posisi admin departemen",
  remove_employees_dept: "Hapus Karyawan Dari",
  want_to_join_dep: "Nama pengguna ingin bergabung dengan Departemen/Lokasi/Tim depname dari perusahaan companyname.",
  you_invited: "Anda telah diundang untuk bergabung dengan Departemen/Lokasi/Tim depname dari perusahaan companyname.",
  dep_remove: "Apakah Anda benar-benar ingin menghapus hak admin untuk departemen atau lokasi dari pengguna?",
  add_dep: "Apakah Anda benar-benar ingin memberikan hak admin untuk departemen atau lokasi kepada pengguna?",
  my_self_dep_remove: "Apakah Anda benar-benar ingin menghapus hak admin departemen dari akun Anda?",
  member: "Anggota",
  admin: "Admin",
  remove_project_admin: "Apakah Anda benar-benar ingin menghapus anggota dari proyek?",
  remove_my_self_project: "Apakah Anda benar-benar ingin menghapus hak admin?",
  remove_member_admin_right: "Apakah Anda benar-benar ingin menghapus hak admin dari pengguna?",
  add_member_admin_right: "Apakah Anda benar-benar ingin menambahkan hak admin kepada pengguna?",
  add_remove_Poss: "Tambah/Hapus posisi admin",
  forward: "Teruskan",
  edit: "Edit",
  only_kjuup_plus_can: "Hanya perusahaan Kjuup+ yang dapat memposting artikel.",
  add_images: "Tambah gambar",
  request_confirmation: 'Undangan proyek tertunda',
  Activity: "Aktivitas",
  latest_messages: "Pesan terbaru",
  hours: "jam",
  minute: "menit",
  seconds: "detik",
  days: "hari",
  yesterday: "kemarin",
  last_week: "minggu lalu",
  next_week: "minggu depan",
  Last_month: "bulan lalu",
  All: "Semua",
  register_plus: "Pendaftaran Plus",
  select_files: "Pilih file",
  monthsFullName: ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"],
  company_deploc_receivers_message: "Tautan undangan ke departemen perusahaan company name di Kjuup. Silakan klik tautan untuk mendaftar Kjuup dan bergabung dengan perusahaan company name.",
  no_news: "Tidak ada berita tersedia",
  reminder: "Pengingat",
  np_reminder: "Tidak ada ToDo",
  move_to_reminder: "Pindah ke ToDo",
  remove_reminder: "Apakah Anda benar-benar ingin menghapus pesan ini dari daftar ToDo Anda?",
  remove_all_reminder: "Hapus semua ToDo",
  remove_all_confirm: "Apakah Anda benar-benar ingin menghapus semua pesan dari daftar ToDo Anda?",
  remove_from_reminder: "Hapus dari Pengingat",
  prevent_email: "Email tidak dapat digunakan sebagai Nama Pengguna.",
  allow_noti: "Silakan izinkan notifikasi.",
  join_cap: "Bergabung",
  pass_minimum: "**Kata sandi memerlukan 12 karakter termasuk huruf kecil, huruf besar, angka dan karakter khusus.",
  pass_error: "Silakan periksa persyaratan kata sandi",
  people_that_like_article: "Orang yang menyukai artikel.",
  people_who_like_article: "Orang yang menyukai artikel Anda.",
  message_delete: "Pesan ini telah dihapus.",
  message_edited: "diedit",
  edit_message: "Edit pesan",
  edit_window_expired: "Pesan hanya dapat diedit dalam 10 menit setelah dikirim.",
  message_edit_save: "Simpan",
  copy: "Salin",
  bookmark: "Markah",
  add_reaction: "Tambah reaksi",
  delete_message: "Hapus pesan",
  more_options: "Opsi lainnya",
  info: "Info",
  link_invite: "Undang melalui tautan",
  ll_nkk: "Undang ke Kjuup",
  selected: "Dipilih",
  is_active: "Aktif",
  inactive: "Tidak aktif",
  last_online: "terakhir online {{when}}",
  remove_user_l: "Hapus",
  link_expire: "Setiap Tautan yang dihasilkan akan berlaku selama 72 jam.",
  company_language: "Bahasa perusahaan",
  company_language_info: "Pemilihan bahasa akan digunakan untuk semua konfirmasi email terkait perusahaan.",
  s_image: "gambar",
  m_image: "gambar",
  removeMsg: "Ketuk untuk menghapus",
  block: 'Blokir',
  unblock: 'Buka blokir',
  blocks: 'Apakah Anda yakin ingin memblokir pengguna ini?',
  unblocks: 'Apakah Anda yakin ingin membuka blokir pengguna ini?',
  bolcked_click_un_block: 'Anda telah memblokir kontak ini. Klik di sini untuk menghapus pemblokiran.',
  you_have_unblocked: 'Anda telah membuka blokir kontak ini.',
  you_have_blocked: 'Anda telah memblokir kontak ini.',
  unblock_to_send: 'Buka blokir pengguna untuk mengirim pesan.',
  pilot_text: "AI Khusus untuk topik konstruksi",
  startup_screen_label: "Layar awal",
  startup_screen_info: "Pilih layar yang dibuka saat Kjuup dimulai.",
  startup_screen_feed: "Home",
  startup_screen_messages: "Pesan",
  startup_screen_saved: "Layar awal diperbarui",
email_on: "Notifikasi email obrolan",
  email_on_grp: "Notifikasi email",
  article_email_on: "Email notification articles",
  article_email_info: "If you enable email notifications for internal articles, you will receive an email when a new internal article is published in your company and department.",
  info_email_room: "Aktifkan atau nonaktifkan notifikasi email untuk proyek ini. Opsi ini hanya tersedia ketika \"Notifikasi email obrolan\" diaktifkan melalui pengaturan pribadi.",
  todo_notification_info: "Anda akan diberi tahu setiap kali tugas baru diberikan kepada Anda.",
  info_val: "Anda akan menerima email jika pesan obrolan baru tidak dibaca dalam waktu singkat. Anda dapat menonaktifkannya untuk proyek atau obrolan tertentu di pengaturannya atau di info grup obrolan.",
  email_groups: "Aktifkan atau nonaktifkan notifikasi email untuk obrolan ini. Opsi ini hanya tersedia ketika \"Notifikasi email obrolan\" diaktifkan melalui pengaturan pribadi dan proyek.",
  add_update_email: "Tambah/Perbarui Email",
  text_to_verifiy: "Opsi \"Notifikasi email obrolan\" hanya dapat diaktifkan jika Anda memiliki alamat email yang terverifikasi di file.",
  stored_email: "Email tersimpan: ",
  verify_email: "Konfirmasi tertunda!",
  join_call: "Bergabung",
  call_is_started: "Panggilan dimulai",
  start_chat: "Mulai Obrolan Langsung?",
  project_rooms: "Proyek",
  download_selected: "Unduh",
  add_employee_confirm: 'Apakah Anda yakin ingin menambahkan pengguna ini ke perusahaan?',
  invalid_deeplink: "URL deeplink tidak valid. Parameter yang diperlukan hilang.",
  deeplink_error: "Tidak dapat memproses deeplink. Silakan coba lagi nanti.",
  reply: "Balas",
  reply_enter: "Masukkan balasan...",
  reply_sent_successfully: "Balasan berhasil dikirim",
  reply_failed: "Gagal mengirim balasan",
  reply_failed_generic: "Gagal mengirim balasan. Silakan coba lagi.",
  replying_to_message: "Membalas pesan",
  cancel_reply: "Batalkan balasan",
  voice_message: "Pesan suara",
  send: "Kirim",
  cancel: "Batal",
  type_your_reply: "Ketik balasan Anda...",
  suggested_replies: "Balasan yang Disarankan",
  suggestions_error: "Gagal memuat saran",
  positive_suggestion_placeholder: "Positive",
  neutral_suggestion_placeholder: "Neutral",
  negative_suggestion_placeholder: "Negative",
  lazy_media_image: "Image — Click to load",
  lazy_media_audio: "Voice message — Click to load",
  lazy_media_doc: "Document — Click to load",
  lazy_media_video: "Video — Click to load",
  suggestion_loading_message: "Tunggu sebentar. Teks Anda sedang disiapkan secara individual untuk Anda.",
  loading_chat_message: "Memuat obrolan...",
  extracting_message: "Mengekstrak pesan...",
  create_todo: "Buat ToDo",
  create_todo_confirmation: "Apakah Anda ingin membuat ToDo dari pesan ini?",
  select_project_required: "Silakan pilih proyek/grup",
  only_assigned_can_change_status: "Hanya pengguna yang ditugaskan yang dapat mengubah status",
  todo_summary: "Ringkasan",
  todo_summary_placeholder: "Masukkan ringkasan todo...",
  todo_date: "Tanggal",
  todo_time: "Waktu",
  todo_date_hint: "Biarkan kosong untuk menggunakan tanggal/waktu pesan asli",
  todo_created_success: "ToDo berhasil dibuat",
  todo_creation_failed: "Gagal membuat ToDo",
  create: "Buat",
  image: "gambar",
  images: "gambar",
  remove_all_images: "Hapus semua gambar",
  remove_image: "Hapus gambar",
  remove_document: "Hapus dokumen",
  remove_recording: "Hapus rekaman",
  play_recording: "Putar rekaman",
  upload_image: "Unggah gambar",
  upload_document: "Unggah dokumen",
  record_audio: "Rekam audio",
  stop_recording: "Hentikan rekaman",
  stop_recording_text: "Hentikan rekaman",
  please_remove_current_attachment: "Silakan hapus lampiran saat ini ke",
  please_upload_image_file: "Silakan unggah file gambar yang valid",
  please_upload_valid_document: "Silakan unggah file dokumen yang valid",
  searching_messages: "Mencari pesan...",
  loading_more: "Memuat lebih banyak...",
  loading_more_users: "Memuat lebih banyak pengguna...",
  load_more_users: "Muat Lebih Banyak Pengguna",
  no_more_users_to_load: "Tidak ada lagi pengguna untuk dimuat",
  no_messages_found: "Tidak ada pesan yang ditemukan",
  try_different_keyword: "Coba kata kunci yang berbeda atau periksa ejaan Anda.",
  search_messages: "Cari pesan, grup obrolan, proyek, dan pengguna...",
  todo: "ToDo",
  np_todo: "Tidak ada ToDo",
  move_to_todo: "Simpan sebagai ToDo",
  remove_todo: "Apakah Anda benar-benar ingin menghapus ToDo?",
  remove_all_todo: "Hapus semua ToDo",
  remove_all_todo_confirm: "Apakah Anda benar-benar ingin menghapus semua ToDo?",
  add_to_todo: "Tambah ke ToDo",
  remove_from_todo: "Hapus dari ToDo",
  confirm: "Konfirmasi",
  ok: "Ok",
  read_more: "Baca selengkapnya",
  show_less: "Tampilkan lebih sedikit",
  show_more: "Tampilkan lebih banyak",
  audio: "Audio",
  video: "Video",
  notification_schedule: "Jadwal notifikasi",
  notification_schedule_desc: "Anda hanya akan menerima notifikasi push dan email pada jam yang Anda pilih. Di luar waktu tersebut, notifikasi akan dijeda.",
  learn_more: "Pelajari lebih lanjut",
  allow_notifications: "Izinkan notifikasi:",
  every_day: "Setiap hari",
  weekdays: "Hari kerja (Senin hingga Jumat)",
  custom: "Kustom",
  monday: "Senin",
  tuesday: "Selasa",
  wednesday: "Rabu",
  thursday: "Kamis",
  friday: "Jumat",
  saturday: "Sabtu",
  sunday: "Minggu",
  to: "hingga",
  notification_settings: "Notifikasi",
  notification_settings_saved: "Pengaturan notifikasi berhasil disimpan",
  notification_settings_error: "Gagal menyimpan pengaturan notifikasi",
  unavailability_note: "Catatan Ketidaktersediaan",
  unavailability_description: "Atur catatan di luar kantor. Selama aktif, catatan ditampilkan kepada orang lain di semua obrolan Anda dan notifikasi dijeda.",
  unavailability_start_date: "Tanggal mulai",
  unavailability_end_date: "Tanggal berakhir",
  unavailability_message: "Pesan",
  unavailability_message_hint: "Gunakan {endDate} sebagai placeholder untuk tanggal kembali Anda.",
  unavailability_replacement: "Kontak Pengganti",
  unavailability_replacement_placeholder: "Masukkan ID pengguna untuk permintaan mendesak",
  unavailability_replacement_current: "Pengganti saat ini",
  unavailability_replacement_hint: "Jika diatur, tautan untuk menghubungi orang ini untuk hal mendesak akan ditampilkan di catatan ketidaktersediaan Anda.",
  unavailability_replacement_none: "Tanpa pengganti (opsional)",
  unavailability_contact_urgent: "Untuk permintaan mendesak hubungi",
  unavailability_default_message: "Saat ini saya tidak berada di kantor dan tidak memiliki akses ke Kjuup. Saya akan tersedia kembali mulai {endDate} dan akan menghubungi Anda saat itu.",
  unavailability_save: "Simpan",
  unavailability_deactivate: "Nonaktifkan",
  unavailability_active_until: "Aktif hingga",
  unavailability_saved: "Catatan ketidaktersediaan disimpan",
  unavailability_save_error: "Gagal menyimpan catatan ketidaktersediaan",
  unavailability_deactivated: "Catatan ketidaktersediaan dinonaktifkan",
  unavailability_end_date_required: "Tanggal berakhir wajib diisi",
  start_time_before_end_time: "Waktu mulai harus sebelum waktu berakhir",
  loading: "Memuat",
  disabled: "Dinonaktifkan",
  enable: "Aktifkan",
  disable: "Nonaktifkan",
  forwarded: "Diteruskan",
  message_forwarded: "Pesan diteruskan!",
  schedule_article_post: "Jadwalkan posting artikel",
  date: "Tanggal",
  time: "Waktu",
  scheduled_for_publication: "Dijadwalkan untuk publikasi",
  article_will_be_published_on: "Artikel akan dipublikasikan pada:",
  reset_selection: "Atur Ulang Pilihan",
  continue: "Lanjutkan",
  cancel: "Batal",
  error_loading_members: "Kesalahan memuat anggota",
  please_fill_all_fields: "Silakan isi semua bidang",
  invalid_email: "Alamat email tidak valid",
  member_added_successfully: "Anggota berhasil ditambahkan",
  error_onboarding_user: "Kesalahan menambahkan pengguna",
  error_creating_chat: "Kesalahan membuat obrolan",
  error_creating_group: "Kesalahan membuat grup",
  new_group: "Grup Baru",
  please_select_or_enter_group_name: "Silakan pilih grup atau masukkan nama grup",
  please_select_or_enter_room_name: "Silakan pilih proyek atau masukkan nama proyek",
  error_creating_room: "Kesalahan membuat proyek",
  error_opening_chat: "Kesalahan membuka obrolan",
  privacy_modal_text: "Pilih \"Pribadi\" hanya jika obrolan tidak berisi konten profesional yang relevan untuk manajer proyek.",
  not_private: "Tidak pribadi",
  private: "Pribadi",
  error_loading_groups: "Kesalahan memuat grup",
  automatic_chat_export: "Ekspor obrolan otomatis",
  automatic_chat_export_info: "Setelah aktivasi, riwayat obrolan akan secara otomatis dikirim ke alamat email yang ditentukan setiap bulan.",
  automatic_chat_export_no_email: "Untuk mengaktifkan ekspor obrolan otomatis, Anda harus menambahkan alamat email terlebih dahulu. Anda dapat menambahkan alamat email Anda di pengaturan pribadi.",
  enter_email: "Masukkan Email",
  update: "Perbarui",
  confirm: "Konfirmasi",
  export_to_email: "Ekspor akan dikirim ke Email berikut.",
  start_chat_button: "Pesan baru",
  matching_existing_chats: "Mencocokkan obrolan yang ada",
  subject: "Subjek",
  add_subject: "Tambah subjek",
  chat_subject: "Subjek Obrolan:",
  set_project_room: "Atur proyek",
  matching_existing_project_rooms: "Mencocokkan proyek yang ada",
  name_project_room: "Nama proyek",
  professional_or_private: "Profesional atau pribadi",
  professional: "Profesional",
  privacy_modal_text_updated: "Pilih \"Pribadi\" hanya jika obrolan tidak berisi konten profesional yang relevan untuk manajer proyek. Obrolan pribadi tidak terlihat oleh manajer proyek.",
  create_internal_chat: "Obrolan eksternal - atau internal?",
  internal_chat_description: "Hanya karyawan perusahaan Anda yang dapat ditambahkan ke obrolan internal.",
  yes: "Ya",
  no: "Tidak",
  chat_is_being_created: "Obrolan sedang dibuat...",
  discard_article_confirm: "Apakah Anda benar-benar ingin membuang perubahan pada artikel ini?",
  please_enter_article_title: "Silakan masukkan judul artikel terlebih dahulu.",
  please_add_mandatory_fields: "Silakan tambahkan semua bidang wajib",
  product_label: "Produk:",
  no_companies_found: "Tidak ada perusahaan yang ditemukan",
  visible_to_all_followers: "Terlihat oleh semua anggota Kjuup",
  only_visible_to_employees: "Hanya terlihat oleh karyawan",
  something_went_wrong: "Terjadi kesalahan, Silakan coba lagi",
  please_select_department: "Silakan pilih departemen/lokasi",
  schedule: "Jadwalkan",
  please_select_future_date_time: "Silakan pilih tanggal dan waktu di masa depan untuk menjadwalkan artikel.",
  please_select_different_date_time: "Silakan pilih tanggal atau waktu yang berbeda untuk menjadwalkan artikel.",
  please_select_later_time: "Silakan pilih waktu yang lebih lambat dari waktu saat ini untuk hari ini.",
  unpin_article: "Lepas pin artikel",
  pin_article: "Sematkan artikel",
  and: "dan",
  others: "lainnya",
  at: "di",
  mute: "Bisukan",
  unmute: "Aktifkan suara",
  chat_muted_successfully: "Obrolan berhasil dibisukan",
  chat_unmuted_successfully: "Suara obrolan berhasil diaktifkan",
  mute_chat_confirm: "Apakah Anda benar-benar ingin membisukan obrolan ini? Anda tidak akan lagi menerima notifikasi untuk pesan baru.",
  unmute_chat_confirm: "Apakah Anda benar-benar ingin mengaktifkan suara obrolan ini? Anda akan kembali menerima notifikasi untuk pesan baru.",
  please_select_group_to_forward: "Silakan pilih grup untuk meneruskan pesan",
  record_not_found: "Catatan tidak ditemukan!",
  please_select_position: "Silakan pilih posisi",
  delete_article_confirm: "Apakah Anda yakin ingin menghapus artikel ini?",
  delete_company_service_confirm: "Apakah Anda yakin ingin menghapus layanan perusahaan?",
  block_translation_confirm: "Apakah Anda benar-benar ingin memblokir terjemahan otomatis di proyek untuk semua anggota perusahaan",
  unblock_translation_confirm: "Apakah Anda benar-benar ingin membuka blokir terjemahan otomatis di proyek untuk semua anggota perusahaan",
  please_select_file: "Silakan pilih file untuk diunggah",
  role_in_building_industry: "Peran dalam industri konstruksi*",
  invalid_email_address: "Alamat Email Tidak Valid",
  please_enter_password: "Silakan masukkan kata sandi",
  password_change_email_sent: "Email telah dikirim ke email Kjuup Anda. Silakan konfirmasi kata sandi baru dengan mengklik tautan konfirmasi di email.",
  please_enter_username: "Silakan masukkan nama pengguna",
  username_same_as_before: "Nama pengguna tidak bisa sama seperti sebelumnya",
  profile_deleted_successfully: "Profil Berhasil Dihapus",
  hardware_requirements: "Persyaratan Perangkat Keras",
  hardware_requirements_list: "• 4GB RAM<br/>• Kecepatan CPU min. 2GHz<br/>• Windows 7 atau lebih tinggi / semua versi macOS",
  submitting: "Mengirim...",
  signing_in: "Masuk...",
  please_enter_service_name: "Silakan masukkan nama layanan",
  something_went_wrong_error: "Aduh! Terjadi kesalahan...",
  something_went_wrong_try_again: "Maaf, terjadi kesalahan di sana. Coba lagi",
  position_label: "Posisi:",
  loading_room: "Memuat proyek...",
  navigating_to_room: "Menavigasi ke proyek",
  loading_chat: "Memuat obrolan...",
  translate: "Terjemahkan",
  show_original: "Tampilkan Asli",
  saving: "Menyimpan...",
  language_selection_info: "Pemilihan bahasa digunakan untuk semua konfirmasi email terkait perusahaan.",
  nav_call: "Panggilan",
  nav_home: "Beranda",
  nav_messages: "Pesan",
  nav_todo: "tugas",
  nav_rooms: "Proyek",
  nav_all_rooms: "Semua proyek",
  pinned_rooms_max: "Anda dapat menyematkan hingga 10 proyek.",
  pinned_room_unpin: "Lepas sematan",
  pinned_rooms_drop: "Seret proyek Anda ke sini untuk pemilihan cepat",
  nav_profile: "Profil",
  nav_company: "Perusahaan",
  nav_company_documents: "Dokumen",
  nav_logout: "Keluar",
  add_member_title: "Tambah Anggota",
  continue_btn: "Lanjutkan",
  search_placeholder: "Cari",
  no_members_found: "Tidak ada anggota yang ditemukan",
  no_groups_found: "Tidak ada grup yang ditemukan",
  no_rooms_found: "Tidak ada proyek yang ditemukan",
  search_users_tab: "Pengguna",
  search_documents_tab: "Dokumen",
  company_documents: "Company documents",
  company_documents_empty: "No documents available.",
  no_media_available: "Tidak ada file",
  no_documents_available: "No documents",
  searching_users: "Mencari pengguna...",
  no_users_found: "Tidak ada pengguna ditemukan",
  search_emails_tab: "Email",
  searching_emails: "Mencari email...",
  no_emails_found: "Tidak ada email ditemukan",
  search_email_addresses_tab: "E-Mail Addresses",
  search_email_content_tab: "E-Mail Content",
  searching_email_content: "Searching email content...",
  no_email_content_found: "No email content found",
  search_email_attachments_tab: "E-Mail Attachments",
  searching_email_attachments: "Searching attachments...",
  no_email_attachments_found: "No attachment matches found",
  email_attachments_label: "Attachments",  searching_email_addresses: "Searching addresses...",
  no_email_addresses_found: "No address matches found",
  email_subject_label: "Subject",
  email_body_label: "Body",
  email_address_received: "Received",
  email_address_sent: "Sent",
  unnamed_group: "Grup Tanpa Nama",
  unnamed_room: "Proyek Tanpa Nama",
  all_members: "Semua",
  room_label: "Proyek:",
  subject_label: "Subjek:",
  no_members: "Tidak ada anggota",
  creating_structure: "Membuat struktur Anda",
  opening_chat: "Membuka obrolan",
  please_wait: "Harap tunggu...",
  loading_todo: "Memuat ToDo...",
  task_updated: "Tugas diperbarui",
  error_updating_task: "Kesalahan memperbarui tugas",
  task_deleted: "Tugas dihapus",
  error_deleting_task: "Kesalahan menghapus tugas",
  delete_task_confirm: "Apakah Anda yakin ingin menghapus tugas ini?",
  description_label: "Deskripsi",
  description_placeholder: "Masukkan deskripsi...",
  date_time_label: "Tanggal & Waktu",
  save_hint: "Ctrl+Enter untuk menyimpan, Esc untuk membatalkan",
  edit_label: "Edit",
  delete_label: "Hapus",
  todo_list_title: "tugas",
  tasks_count: "tugas",
  search_placeholder_todo: "Cari...",
  select_task_to_open_chat: "Pilih tugas untuk membuka obrolan",
  today: "Hari ini",
  yesterday: "Kemarin",
  time_suffix: "",
  from_chat: "ToDo Sumber",
  assigned_to: "Ditugaskan ke",
  assign_users: "Tetapkan pengguna",
  no_users_assigned: "Tidak ada pengguna yang ditugaskan",
  assign: "Tetapkan",
  assign_to: "Tetapkan ke...",
  navigate_to_chat: "Navigasi ke Obrolan",
  navigate_to_email: "Buka email",
  show_original_message: "Tampilkan sumber",
  hide_original_message: "Sembunyikan sumber",
  status_pending: "Tertunda",
  status_in_progress: "Sedang Berlangsung",
  status_completed: "Selesai",
  show: "Tampilkan",
  close: "Tutup",
  // Log translations
  status_confirmed: "[Dikonfirmasi]",
  log_todo_created: "ToDo [dibuat]",
  log_todo_confirmed: "ToDo [dikonfirmasi]",
  log_todo_deleted: "ToDo [dihapus]",
  log_todo_updated: "ToDo [diperbarui]",
  log_description_updated: "[Deskripsi diperbarui]",
  log_deadline_updated: "[Tenggat waktu diperbarui]",
  log_assigned_to: "[Ditugaskan ke] {name}",
  log_unassigned_from: "[Dibatalkan dari] {name}",
  log_assignment_added: "[Penugasan ditambahkan]: {name}",
  log_assignment_removed: "[Penugasan dihapus]: {name}",
  log_status_updated: "[Status diubah dari] {from} [ke] {to}",
  log_status_changed: "[Status diubah]",
  log_status_changed_to: "[Status diubah menjadi] {status}",
  log_changed_status_to: "[Mengubah status menjadi]:",
  log_for_user: "[untuk pengguna]:",
  log_user_updated_status: "[Pengguna memperbarui status todo mereka]",
  log_changed_date_to: "[Mengubah tanggal menjadi]:",
  log_changed_description_to: "[Mengubah deskripsi menjadi]:",
  log_moved_to: "[Dipindahkan ke] {status}",
  todo_status_updated_from: "[dari]",
  todo_status_updated_to: "[ke]",
  filter_pending: "Tertunda",
  filter_confirmed: "Dikonfirmasi",
  filter_assigned_to_me: "Tugas saya",
  filter_assigned_by_me: "Didelegasikan",
  todo_project_label: "Proyek:",
  assigned_users: "Pengguna yang ditugaskan:",
  todo_chat_label: "Obrolan:",
  history: "Riwayat",
  todo_assigned_by: "Ditugaskan oleh:",
  todo_assigned_push: "ToDo ditugaskan:",
  todo_assigned_push_empty: "ToDo baru telah ditugaskan kepada Anda.",
  search_groups: "Grup",
  search_chat_groups: "Grup obrolan",
  search_project_room: "Proyek",
  search_messages_tab: "Pesan",
  searching_groups: "Mencari grup...",
  searching_rooms: "Mencari proyek...",
  no_groups_found: "Tidak ada grup ditemukan",
  no_rooms_found: "Tidak ada proyek ditemukan",
  create_poll: "Jajak pendapat",
  poll_question_label: "PERTANYAAN",
  poll_question_placeholder: "Ajukan pertanyaan",
  poll_options_label: "OPSI",
  poll_option: "Opsi",
  poll_add_option: "Tambah opsi",
  poll_allow_multiple: "Izinkan beberapa jawaban",
  poll_multiple_allowed: "Pilih satu atau lebih opsi",
  poll_select_option: "Pilih satu opsi",
  poll_view_votes: "Lihat suara",
  poll_vote_singular: "suara",
  poll_vote_plural: "suara",
  poll_votes: "Hasil jajak pendapat",
  poll_no_votes_yet: "Belum ada suara",
  transcript_step_processing: "Transkripsi sedang berlangsung...",
  ai_transcript_tab: "AI-Transkripsi",
  ai_transcript_info: "Hanya tersedia untuk pesan suara yang dibuat setelah 09.03.2026.",
  transcript_more: "...selengkapnya",
  transcript_less: "...lebih sedikit",
  ki_transcript_voice_message: "KI-Transkrip pesan suara",
  ki_image_analysis: "Analisis gambar berbasis AI",
  type_message: "Ketik pesan",
  email_tab_messages: "Pesan",
  email_tab_email: "E-Mail",
  email_tab_messages_and_email: "Messages & E-Mail",
  email_tab_email_details: "E-Mail Details",
  email_accounts: "Akun Email",
  email_connect_gmail: "Hubungkan Gmail",
  email_connect_outlook: "Hubungkan Outlook",
  email_no_accounts: "Tidak ada akun email yang terhubung",
  email_no_accounts_hint: "Hubungkan akun email di pengaturan profil Anda",
  email_no_messages: "Tidak ada email",
  email_from: "Dari",
  email_to: "Kepada",
  email_subject: "Subjek",
  email_disconnect: "Putuskan",
  email_disconnect_confirm: "Apakah Anda yakin ingin memutuskan akun email ini? Semua email yang disinkronkan akan dihapus.",
  email_account_disconnected: "Akun email berhasil diputuskan",
  email_account_disconnect_failed: "Gagal memutuskan akun",
  email_connecting: "Menghubungkan...",
  email_account_connected: "Akun berhasil terhubung",
  email_signature: "Signature",
  email_signature_placeholder: "Enter your email signature...",
  email_signature_save: "Save",
  email_signature_saved: "Saved",
  email_go_to_settings: "Buka Pengaturan",
  email_date: "Tanggal",
  email_reply: "Balas",
  email_forward: "Teruskan",
  email_copy_text: "Salin teks",
  email_text_copied: "Disalin!",
  email_text_copy_failed: "Teks tidak dapat disalin.",
  email_delete: "Hapus",
  email_not_spam: "Bukan Spam",
  email_not_spam_success: "Email dipindahkan ke kotak masuk.",
  email_not_spam_failed: "Gagal memindahkan ke kotak masuk.",
  email_delete_confirm: "Apakah Anda yakin ingin menghapus email ini?",
  email_delete_from_folder: "Apakah Anda yakin ingin menghapus dari {folder}?",
  email_delete_permanent_from_folder:
    "Apakah Anda yakin ingin menghapus secara permanen dari {folder}? Tindakan ini tidak dapat dibatalkan.",
  email_save_draft_confirm: "Apakah Anda ingin menyimpan email ini sebagai draf?",
  email_save_draft: "Simpan Draf",
  email_discard: "Buang",
  email_back_to_compose: "Kembali menulis",
  email_draft_saved: "Draf disimpan.",
  email_draft_save_failed: "Gagal menyimpan draf.",
  email_loading: "Memuat email...",
  email_archived: "Archived",
  email_mark_spam: "Mark as spam",
  email_marked_spam: "Marked as spam",
  email_group_today: "Today",
  email_group_yesterday: "Yesterday",
  email_group_this_week: "This week",
  email_group_earlier: "Earlier",
  email_search: "Search",
  email_search_placeholder: "Search mail",
  email_no_results: "No matching messages",
  email_clear_search: "Clear search",
  email_star: "Star",
  email_unstar: "Unstar",
  email_starred: "Starred",
  email_folder_starred: "Starred",
  email_select: "Pilih",
  email_attachment_singular: "Lampiran",
  email_attachment_plural: "Lampiran",
  email_back: "Kembali",
  email_download: "Unduh",
  email_close: "Tutup",
  email_preview: "Pratinjau",
  email_preview_not_available: "Pratinjau tidak tersedia",
  email_preview_failed: "Pratinjau tidak tersedia",
  select_attachments: "Pilih lampiran",
  email_loading_preview: "Memuat pratinjau...",
  email_mark_unread_failed: "email tidak dapat ditandai sebagai belum dibaca.",
  email_delete_failed: "email tidak dapat dihapus.",
  filter_all: "Semua",
  filter_email: "E-Mail",
  filter_kjuup_messages: "Kjuup",
  filter_direct_messages: "Pesan Langsung",
  my_notes: "My Space",
  filter_internal_groups: "Obrolan grup internal",
  filter_external_groups: "Obrolan grup eksternal",
  filter_group_chats: "Obrolan grup",
  filter_groups_internal: "Internal",
  filter_groups_external: "Eksternal",
  filter_unread_only: "Hanya belum dibaca",
  room_daily_briefing_info: "Jika diaktifkan, laporan untuk proyek ini dibuat setiap 24 jam pada waktu yang ditentukan di pengaturan pribadi — tetapi hanya jika ada aktivitas selama periode tersebut.",
  email_select_all: "Pilih semua",
  email_deselect_all: "Hapus semua pilihan",
  email_reply_all: "Balas semua",
  email_reply_placeholder: "Ketik balasan Anda...",
  email_forward_placeholder: "Tambahkan pesan...",
  email_edit_draft: "Edit draf",
  email_attach: "Lampirkan",
  email_attachment_from_original: "Dari pesan asli",
  email_remove: "Hapus",
  email_drop_files: "Seret file untuk dilampirkan",
  email_loading_attachments: "Memuat lampiran...",
  email_archive: "Arsipkan",
  mark_unread: "Tandai belum dibaca",
  mark_read: "Tandai sudah dibaca",
  email_all_accounts: "Semua akun",
  email_error: "Kesalahan",
  email_delete_email_failed: "Gagal menghapus email.",
  enter_url: "Masukkan URL",

  // ─── Kjuup subscription ───────────────────────────────────────────
  kjuup_io: 'Kjuup.io',
  kjuup_io_manage_subscription: 'Manage your subscription',
  kjuup_io_subscribe_now: 'Berlangganan sekarang',
  kjuup_io_hero_subtitle: 'Upgrade to unlock premium features and get more out of every project.',
  kjuup_io_trial_badge: 'UJI COBA GRATIS 1 BULAN',
  kjuup_io_trial_title: 'Unlock Kjuup.io Premium',
  kjuup_io_trial_subtitle: 'Connect your email, receive AI-powered smart replies and synchronize your tasks with your calendar.',
  kjuup_io_trial_no_payment: 'No payment today.',
  kjuup_io_trial_trust: 'Tidak ada pembayaran hari ini. Detail kartu kredit tidak diminta sebelum langganan berbayar dimulai.',
  kjuup_io_after_trial_monthly: 'After trial: {price}/month',
  kjuup_io_after_trial_yearly: 'After trial: {price}/year',
  kjuup_io_price_per_month: '{price}/month',
  kjuup_io_price_per_year: '{price}/year',
  kjuup_io_start_free_trial: 'Start free now � no risk',
  kjuup_io_trial_footnote: 'No payment today. Then {price}. Cancel anytime.',
  kjuup_io_feature_email: 'Kelola semua akun email langsung di Kjuup',
  kjuup_io_feature_assign: 'Automatically assign emails and attachments to projects',
  kjuup_io_feature_ai: 'AI menulis balasan – Anda hanya mengonfirmasi',
  kjuup_io_feature_tasks: 'Tugas & kalender selalu diperbarui secara otomatis',
  kjuup_io_choose_plan: 'Pilih paket',
  kjuup_io_plan_monthly: 'Bulanan',
  kjuup_io_plan_yearly: 'Tahunan',
  kjuup_io_plan_monthly_desc: 'Billed monthly · cancel anytime',
  kjuup_io_plan_yearly_desc: 'Save {pct}% with annual booking',
  kjuup_io_save_badge: 'SAVE {pct}%',
  kjuup_io_per_month_annual: '{price} / month · Save {pct}% with annual booking',
  kjuup_io_subscribe: 'Subscribe',
  kjuup_io_secured_stripe: 'Diamankan oleh Stripe · batalkan kapan saja',
  kjuup_io_your_subscription: 'YOUR SUBSCRIPTION',
  kjuup_io_status_active: 'ACTIVE',
  kjuup_io_status_cancels_soon: 'CANCELS SOON',
  kjuup_io_status_switch_scheduled: 'SWITCH SCHEDULED',
  kjuup_io_label_plan: 'Plan',
  kjuup_io_label_price: 'Price',
  kjuup_io_label_status: 'Status',
  kjuup_io_label_renews: 'Renews on',
  kjuup_io_label_access_until: 'Access until',
  kjuup_io_switching_to: 'Switching to {plan} on {date}',
  kjuup_io_cancel_pending_note: 'Your subscription is set to cancel and won\'t renew. You keep access until the date above.',
  kjuup_io_resume: 'Resume subscription',
  kjuup_io_switch_to_plan: 'Switch to {plan} plan',
  kjuup_io_undo_switch: 'Undo scheduled change',
  kjuup_io_cancel_subscription: 'Cancel subscription',
  kjuup_io_switch_modal_title: 'Switch to {plan} plan?',
  kjuup_io_billed_yearly: 'Billed yearly',
  kjuup_io_billed_monthly: 'Billed monthly',
  kjuup_io_switch_modal_note: 'Starts on {date}, when your current {plan} plan ends. No charge today — you keep your current plan until then.',
  kjuup_io_confirm_switch: 'Confirm switch',
  kjuup_io_not_now: 'Not now',
  kjuup_io_cancel_modal_title: 'Cancel subscription?',
  kjuup_io_cancel_modal_note: 'You\'ll keep access to Kjuup.io until the end of your current billing period. After that it won\'t renew.',
  kjuup_io_cancel_modal_note_with_date: 'You\'ll keep access to Kjuup.io until the end of your current billing period ({date}). After that it won\'t renew.',
  kjuup_io_cancel_plan: 'Cancel plan',
  kjuup_io_keep_subscription: 'Keep my subscription',
  kjuup_io_toast_payment_failed: 'Payment failed',
  kjuup_io_toast_activating: 'Pembayaran diterima. Mengaktifkan langganan Anda…',
  kjuup_io_toast_activating_soon: 'Pembayaran diterima. Langganan Anda akan segera aktif.',
  kjuup_io_toast_cancel_period: 'Your subscription will cancel at the end of the period',
  kjuup_io_toast_cancel_fail: 'Unable to cancel subscription',
  kjuup_io_toast_switch_scheduled: 'You\'ll move to the {plan} plan when your current period ends',
  kjuup_io_toast_switch_fail: 'Unable to switch plan',
  kjuup_io_toast_resumed: 'Your subscription will keep renewing',
  kjuup_io_toast_resume_fail: 'Unable to resume subscription',
  kjuup_io_toast_undo: 'Scheduled plan change canceled',
  kjuup_io_toast_undo_fail: 'Unable to cancel the scheduled change',
  kjuup_io_email_locked_body: 'Email is part of Kjuup.io. Activate a plan to use the Email tab.',
  kjuup_io_connect_email: 'Connect email with Kjuup.io',
  kjuup_io_activate_to_connect_email: 'Activate Kjuup.io to connect email accounts',

  kjuup_io_trial_no_card: 'No credit card details are requested before your paid subscription starts.',
  kjuup_io_status_trialing: 'TRIAL',
  kjuup_io_trial_days_left: '{days} days left in your free trial',
  kjuup_io_trial_left_hours: '{count} jam lagi',
  kjuup_io_trial_left_hour: '1 jam lagi',
  kjuup_io_trial_left_minutes: '{count} menit lagi',
  kjuup_io_trial_left_minute: '1 menit lagi',
  kjuup_io_trial_left_seconds: '{count} detik lagi',
  kjuup_io_trial_left_second: '1 detik lagi',
  kjuup_io_trial_ending_now: 'Masa uji coba Anda sedang berakhir…',
  kjuup_io_request_timeout: 'Koneksi habis waktu. Silakan coba lagi.',
  kjuup_io_info_days_free: '{days} hari sepenuhnya gratis – langganan dimulai setelah masa uji coba.',
  kjuup_io_discount_total: 'Diskon Anda: {percent}%',
  kjuup_io_discount_company: '{company}: {percent}%',
  kjuup_io_discount_personal: 'Pribadi: {percent}%',
  kjuup_io_trial_ends_tomorrow: 'Your free trial ends tomorrow',
  kjuup_io_trial_ends_today: 'Your free trial ends today',
  kjuup_io_banner_dismiss: 'Tutup',
  kjuup_io_billing_after_trial: 'You\'ll be charged after your trial ends on {date}.',
  kjuup_io_trial_ended_title: 'Uji coba gratis Anda telah berakhir',
  kjuup_io_trial_ended_body: 'Berlangganan Kjuup.io untuk terus menggunakan email dan fitur premium lainnya.',
  kjuup_io_subscribe_to_continue: 'Subscribe now to continue',
  kjuup_io_trial_active_title: 'You\'re on a free trial',
  kjuup_io_trial_active_subtitle: 'Choose a plan and subscribe — billing starts when your trial ends.',
  kjuup_io_toast_trial_started: 'Uji coba gratis Anda telah dimulai',
  kjuup_io_toast_trial_fail: 'Tidak dapat memulai uji coba gratis',
  kjuup_io_trial_try_month: 'Try Kjuup.io free for one month.',
  kjuup_io_per_month: 'per month',
  kjuup_io_price_month_line: '{price} / bulan',
  kjuup_io_save_amount_year: 'Hemat {price} per tahun',
  kjuup_io_billed_annually_amount: '{price} ditagih tahunan',
  kjuup_io_save_yearly: 'Save {pct}% with yearly billing.',
  kjuup_io_savings_pct: '{pct}% savings',
  kjuup_io_features_title: 'Yang Anda dapatkan:',
  kjuup_io_info_one_month_free: 'One month free',
  kjuup_io_info_plan_after_trial: 'Your selected subscription starts after the trial.',
  kjuup_io_info_cancel_trial: 'Cancel anytime during the trial.',
  kjuup_io_info_no_card: 'Kartu kredit tidak diperlukan – mulai segera tanpa data pembayaran.',
  kjuup_io_info_cancel_anytime: 'Batalkan kapan saja – tanpa komitmen, tanpa risiko.',
  kjuup_io_cta_plan_begins: 'Your selected plan begins after the free trial.',
  kjuup_io_billing_period_aria: 'Periode penagihan',
  kjuup_io_subscription_info_title: 'Subscription information',
  kjuup_io_first_payment_on: 'First payment on {date}.',
  kjuup_io_renews_on: 'Renews on {date}.',
  kjuup_io_toast_card_saved: 'Metode pembayaran disimpan. Anda akan ditagih saat masa uji coba berakhir.',
  calendar_sync_info: 'Sinkronkan otomatis semua ToDo Kjuup dengan kalender Anda.',
  calendar_no_accounts: 'Belum ada kalender yang terhubung.',
  article_new_badge: 'BARU',
  article_new_posts: '{0} postingan baru',
  documents: 'Dokumen',
  add_documents: 'Tambah dokumen',
  no_preview_available: 'Pratinjau tidak tersedia',
  no_preview_hint: 'Jenis berkas ini tidak dapat dipratinjau, tetapi tetap akan dikirim.',
  max_documents_reached: 'Anda dapat melampirkan maksimal 10 dokumen sekaligus.',
  open_file: 'Buka file',
  twofa_title: 'Autentikasi dua faktor',
  twofa_method_totp: 'Aplikasi autentikator',
  twofa_method_sms: 'Pesan teks',
  twofa_method_email: 'Email',
  twofa_enter_app: 'Masukkan kode 6 digit dari aplikasi autentikator.',
  twofa_enter_sms: 'Masukkan kode 6 digit yang kami kirim lewat SMS.',
  twofa_enter_email: 'Masukkan kode 6 digit yang kami kirim ke email.',
  twofa_resend: 'Kirim ulang kode',
  twofa_try_another: 'Coba metode lain',
  twofa_remember_device: 'Jangan tanya lagi di perangkat ini selama 30 hari',
  twofa_sent: 'Kami telah mengirim kode.',
  twofa_invalid_code: 'Kode salah. Silakan coba lagi.',
  twofa_something_wrong: 'Terjadi kesalahan. Silakan coba lagi.',
  twofa_method_unavailable: 'Metode itu tidak tersedia.',
  twofa_on_desc: 'Autentikasi dua faktor aktif. Anda perlu kode setiap kali masuk.',
  twofa_off_desc: 'Tambahkan langkah kedua setelah kata sandi. Aplikasi autentikator paling aman.',
  twofa_methods: 'Metode',
  twofa_on: 'Aktif',
  twofa_add: 'Tambah',
  twofa_default_method: 'Metode default',
  twofa_default: 'Default',
  twofa_turn_off: 'Matikan',
  twofa_disable_hint: 'Masukkan kata sandi dan kode saat ini untuk mematikan autentikasi dua faktor.',
  twofa_disable_need: 'Masukkan kata sandi dan kode verifikasi.',
  twofa_code_placeholder: 'Kode 6 digit atau kode cadangan',
  twofa_send_code: 'Kirim kode',
  twofa_primary_updated: 'Metode default diperbarui.',
  twofa_disabled: 'Autentikasi dua faktor sekarang nonaktif.',
  twofa_enabled: 'Autentikasi dua faktor sekarang aktif.',
  twofa_totp_help: 'Pindai kode QR ini dengan Google Authenticator, Authy, atau 1Password. Anda juga bisa memasukkan kunci secara manual.',
  twofa_secret_copied: 'Kunci disalin',
  twofa_sms_help: 'Masukkan nomor dalam format internasional. Kami akan mengirim kode 6 digit lewat SMS.',
  twofa_email_help: 'Kami akan mengirim kode 6 digit ke email akun Anda.',
  twofa_backup_title: 'Kode cadangan',
  twofa_backup_help: 'Simpan kode sekali pakai ini di tempat aman. Setiap kode hanya bisa dipakai sekali jika ponsel hilang.',
  twofa_copy_codes: 'Salin kode',
  twofa_codes_copied: 'Kode cadangan disalin',
  twofa_regenerate: 'Dapatkan kode cadangan baru',
  twofa_regenerate_hint: 'Ini mengganti kode cadangan yang belum digunakan. Masukkan kata sandi dan kode saat ini.',
  twofa_backup_remaining: '{n} kode cadangan yang belum digunakan tersisa',
  twofa_new_codes: 'Kode cadangan baru',
  twofa_sms_unavailable: 'Kode SMS belum tersedia.',
  todoist_sync_title: "Todoist",
  todoist_sync_info: "Tugas Kjuup yang ditugaskan kepadamu disalin ke proyek Kjuup di Todoist. Perubahan di Todoist tidak disalin kembali.",
  todoist_connect: "Hubungkan Todoist",
  todoist_connected: "Todoist terhubung",
  todoist_connect_failed: "Gagal menghubungkan Todoist",
  todoist_disconnect: "Putuskan",
  todoist_disconnected: "Todoist terputus",
  todoist_disconnect_confirm: "Putuskan Todoist? Tugas yang sudah ada di Todoist tetap ada. Sinkronisasi berhenti.",
  todoist_sync_now: "Sinkronkan sekarang",
  todoist_syncing: "Menyinkronkan…",
  todoist_sync_done: "Sinkronisasi selesai",
  todoist_sync_failed: "Sinkronisasi gagal",
  todoist_auth_error: "Hubungkan lagi Todoist untuk melanjutkan sinkronisasi.",
  todoist_last_sync: "Sinkronisasi terakhir",
  todoist_not_connected: "Todoist belum terhubung",
  todoist_auth_url_failed: "Halaman otorisasi Todoist tidak dapat dibuka.",
  recommend_text: "Gabung ke Kjuup supaya tetap terhubung dan komunikasimu tetap teratur. Satukan semua kanalmu, simpan pesan di proyek yang tepat, dan mulai setiap pagi dengan ringkasan serta tugas-tugasmu – semuanya tersinkron dengan aplikasi yang sudah kamu pakai. Mulai gratis:",
  pro_auth_signin_title: 'Selamat datang kembali',
  pro_auth_signin_sub: 'Masuk dengan email kerja Anda.',
  pro_auth_email_or_username: 'Email atau nama pengguna',
  pro_auth_email_placeholder: 'nama@perusahaan.de',
  pro_auth_forgot_password: 'Lupa kata sandi?',
  pro_auth_create_account: 'Buat akun',
  pro_auth_show_password: 'Tampilkan kata sandi',
  pro_auth_hide_password: 'Sembunyikan kata sandi',
  pro_auth_register_sub: 'Kami akan mengirimkan tautan untuk mengonfirmasi email Anda.',
  pro_auth_register_plus_sub: 'Pilih nama pengguna dan kata sandi. Selanjutnya Anda mengatur PIN keamanan.',
  pro_auth_check_credentials: 'Periksa email dan kata sandi Anda',
  pro_news_export_pdf: 'Ekspor sebagai PDF',
  pro_news_pdf_failed: 'PDF tidak dapat dibuat.',
  pro_news_pdf_attachments: 'Lampiran',
  pro_news_pdf_video: 'Video',
  pro_auth_forgot_sub: 'Masukkan email Anda dan kami akan mengirimkan tautan untuk mereset kata sandi Anda.',
  pro_auth_send_link: 'Kirim tautan reset',
  pro_auth_plus_reset: 'Reset dengan PIN',
  pro_auth_show_pin: 'Tampilkan PIN',
  pro_auth_hide_pin: 'Sembunyikan PIN',
  v2_auth_plus_only: 'Hanya Kjuup+',
  room_action_media: "File",
  room_tab_overview: "Ringkasan",
  room_tab_history: "Riwayat",
  chat_info_media: "File",
  messages: "pesan",
  pro_todo_project_required: "Silakan pilih proyek",
  pro_todo_choose_project: "Untuk proyek apa tugas ini?",
  cockpit_report_delete_confirm: "Hapus laporan harian ini?",
  cockpit_report_deleted: "Laporan harian dihapus",
  cockpit_tab_company: "Perusahaan",
  cockpit_bookmarked_priorities: "Tugas yang ditandai",
  cockpit_load_error: "Cockpit tidak dapat dimuat.",
  cockpit_retry: "Coba lagi",
  cockpit_yesterday: "Kemarin",
  cockpit_greeting_morning: "Selamat pagi",
  cockpit_greeting_day: "Selamat siang",
  cockpit_greeting_evening: "Selamat malam",
  cockpit_assistant_q_open: "Apa yang masih terbuka hari ini?",
  cockpit_assistant_q_summarize: "Ringkas chat {{room}}",
  cockpit_assistant_q_overdue: "Tugas mana yang terlambat?",
  cockpit_assistant_new: "{{n}} baru",
  cockpit_assistant_important: "{{n}} penting",
  cockpit_assistant_title: "Asisten Kjuup",
  cockpit_assistant_hint: "Ketuk dan tanyakan",
  room_overview_priority_no_detail: "Laporan tidak memberikan detail lebih lanjut tentang prioritas ini.",
  room_overview_priority_from: "Sumber: {{name}}",
  room_overview_priority_open_task: "Buka tugas",
  cockpit_priority_position: "{{index}} dari {{total}} prioritas",
  room_overview_today_title: "Penting hari ini",
  room_overview_all_tasks: "Semua",
  room_overview_tasks_empty: "Tidak ada tenggat atau tugas terbuka",
  room_overview_appointments_empty: "Tidak ada janji temu mendatang",
  room_overview_no_priorities: "Tidak ada prioritas terbuka di laporan terbaru.",
  cockpit_report_top5: "5 prioritas teratas",
  cockpit_report_todo_created: "ToDo dibuat",
  cockpit_report_source_missing: "Pesan sumber tidak ditemukan.",
  delete_bookmarked_priority_confirm: "Yakin ingin menghapus tugas yang ditandai ini?",
  cockpit_report_create_todo: "Buat ToDo",
  cockpit_priorities_deleting: "Menghapus …",
  cockpit_priorities_select: "Hapus beberapa",
  cockpit_report_none: "Tidak ada entri.",
  cockpit_priorities_delete_confirm: "Yakin ingin menghapus {count} tugas yang ditandai?",
  cockpit_priorities_delete_failed: "{count} tugas tidak dapat dihapus",
  cockpit_priorities_deleted: "{count} tugas dihapus",
  cockpit_priorities_selected: "{count} dipilih",
  cockpit_channel_connected: "Terhubung",
  cockpit_channel_not_connected: "Tidak terhubung",
  cockpit_channel_connect: "Hubungkan",
  cockpit_channel_chat: "Chat Kjuup",
  cockpit_channel_active: "Aktif",
  cockpit_channel_hidden: "Disembunyikan",
  cockpit_channel_enable: "Aktifkan",
  cockpit_channel_email: "Email",
  cockpit_channel_check: "Periksa koneksi",
  cockpit_channel_fix: "Periksa",
  cockpit_channel_forward: "Alamat penerusan",
  cockpit_channel_not_set_up: "Belum disiapkan",
  cockpit_channel_set_up: "Siapkan",
  cockpit_channel_teams: "Microsoft Teams",
  cockpit_channel_broken: "Koneksi terputus",
  cockpit_channel_importing: "Mengimpor",
  cockpit_channel_removing: "Memutuskan koneksi",
  cockpit_channel_reconnect: "Hubungkan ulang",
  cockpit_channels_title: "Kanal",
  cockpit_company_role_super_admin: "Admin perusahaan",
  cockpit_company_role_dept_admin: "Admin departemen",
  cockpit_company_role_member: "Karyawan",
  cockpit_company_none: "Perusahaan Kjuup+ tidak ditemukan",
  cockpit_company_eyebrow: "Perusahaan",
  cockpit_company_inactive: "tidak aktif",
  cockpit_company_settings: "Pengaturan perusahaan",
  cockpit_company_employees: "Karyawan",
  cockpit_company_internal_rooms: "Proyek internal",
  cockpit_report_all_projects: "Semua proyek",
  cockpit_report_progress_emails: "Menganalisis email",
  cockpit_report_progress_chats: "Menganalisis pesan chat",
  cockpit_report_progress_documents: "Menganalisis lampiran dan dokumen",
  cockpit_report_progress_tasks: "Menganalisis tugas",
  cockpit_report_progress_summarizing: "Menganalisis konten",
  cockpit_report_progress_reading: "Menggunakan kembali konten yang sudah dianalisis",
  cockpit_report_progress_collecting: "Mengumpulkan email, chat, dan tugas dari proyek Anda",
  cockpit_report_progress_priorities: "Menyusun prioritas, tenggat, dan keputusan",
  cockpit_report_progress_queued: "Menyiapkan laporan",
  cockpit_report_creating_title: "Laporan harian Anda sedang disiapkan",
  cockpit_report_progress_count_one: "1 item dianalisis",
  cockpit_report_progress_count_many: "{{count}} item dianalisis",
  cockpit_report_progress_hint: "Biasanya memerlukan satu hingga dua menit – Anda dapat terus menggunakan cockpit selama itu.",
  cockpit_report_time_hint: "Laporan harian dibuat setiap hari pukul {{hour}}:00 untuk lima proyek paling aktif.",
  room_overview_priorities_title: "Status dan prioritas terkini",
  room_overview_as_of: "Per {{time}}",
  cockpit_report_delete: "Hapus laporan harian",
  email_tag_daily_briefing: "Laporan harian",
  cockpit_report_unread: "Baru",
  cockpit_report_clear_project: "Tampilkan semua proyek",
  cockpit_filter_project: "Proyek",
  cockpit_filter_all_projects: "Semua proyek",
  cockpit_report_recreate: "Buat ulang laporan harian",
  cockpit_report_hide_previous: "Sembunyikan laporan harian sebelumnya",
  cockpit_report_show_previous: "Tampilkan laporan harian sebelumnya",
  cockpit_report_room_empty: "Belum ada laporan harian untuk proyek ini",
  cockpit_report_empty: "Belum ada laporan harian",
  cockpit_report_room_empty_hint: "Buat laporan harian hanya untuk proyek ini.",
  cockpit_report_needs_mailbox: "Hubungkan akun email agar Kjuup dapat membuat laporan harian dengan tugas otomatis.",
  cockpit_report_create: "Buat laporan harian",
  cockpit_email_connect: "Hubungkan email",
  cockpit_email_none_title: "Belum ada akun email yang terhubung",
  cockpit_email_none_reports: "Hubungkan kotak surat Anda agar Kjuup dapat menetapkan email masuk ke proyek Anda dan membuat laporan harian dengan tugas.",
  cockpit_email_none_client: "Hubungkan Gmail, Outlook, atau IMAP untuk membaca, menetapkan, dan membalas email langsung di Kjuup.io.",
  cockpit_email_reports_title: "Klien email saat ini",
  cockpit_email_reports_text: "Tanpa kotak masuk di Kjuup.io · {{rooms}} proyek dengan laporan harian pukul {{hour}}:00 · email masuk ditetapkan ke proyek Anda.",
  cockpit_email_reports_rooms: "Kelola proyek",
  cockpit_email_settings: "Pengaturan email",
  cockpit_email_error_title: "Periksa koneksi",
  cockpit_email_client_title: "Kotak masuk terhubung",
  cockpit_email_accounts_n: "{{n}} akun terhubung",
  cockpit_email_last_sync: "sinkronisasi terakhir {{when}}",
  cockpit_email_report_at: "Laporan harian pukul {{hour}}:00",
  cockpit_email_open_inbox: "Buka kotak masuk",
  cockpit_email_eyebrow: "Kjuup-Email",
  cockpit_email_accounts_label: "Alamat email terhubung",
  email_folder_sent: "Item Terkirim",
  email_no_subject: "(Tanpa subjek)",
  cockpit_email_detail_loading: "Memuat email …",
  cockpit_email_detail_failed: "Email tidak dapat dimuat.",
  cockpit_email_detail_empty: "Email ini tidak memiliki teks.",
  cockpit_personal_settings: "Pengaturan pribadi",
  cockpit_companies: "Perusahaan",
  cockpit_title: "Cockpit",
  cockpit_back: "Kembali ke ringkasan",
  cockpit_day_overview: "Hari Anda sekilas",
  email_saved_to_project: "Email disimpan ke proyek",
  email_classify_need_project: "Masukkan nama proyek",
  cockpit_email_deleted: "Email dihapus",
  cockpit_email_sent_empty: "Belum ada email terkirim.",
  cockpit_email_incoming_empty: "Belum ada email masuk.",
  cockpit_email_incoming_title: "Email",
  cockpit_email_incoming_sub: "Tetapkan email masuk dan terkirim ke proyek Anda. Anda dapat menyesuaikan penetapan di sini.",
  cockpit_email_incoming_unassigned_n: "{{n}} belum ditetapkan",
  cockpit_email_folder_inbox: "Kotak masuk",
  cockpit_email_folder_sent: "Terkirim",
  cockpit_email_open: "Buka email",
  cockpit_email_incoming_suggested: "Disarankan: {{room}}",
  cockpit_email_incoming_apply: "Terapkan",
  cockpit_email_incoming_adjust: "Ubah penetapan",
  cockpit_email_incoming_saving: "Menyimpan …",
  cockpit_email_incoming_unassigned: "Belum ditetapkan",
  cockpit_email_incoming_show_less: "Tampilkan lebih sedikit",
  cockpit_email_incoming_show_all: "Tampilkan semua {{n}}",
  cockpit_io_settings: "Pengaturan Kjuup.io",
  cockpit_io_settings_sub: "Paket dan kursi, penugasan karyawan, penagihan, dan faktur.",
  products_coming_soon: "Segera hadir",
  cockpit_upsell_io_title: "Kantor yang berpikir bersama Anda",
  cockpit_upsell_io_text: "Hubungkan akun email Anda dengan Kjuup. Email, lampiran, dan pesan disimpan otomatis di proyek yang sesuai dan dapat disimpan di server Anda. Setiap hari Anda menerima ringkasan semua proyek dengan poin penting dari semua konten, dan tugas Anda tersinkron dengan kalender atau aplikasi to-do Anda.",
  cockpit_upsell_io_soon_title: "Belum dapat dipesan",
  cockpit_upsell_io_soon_text: "Kjuup.io segera diluncurkan. Minta informasi sekarang – kami akan memberi tahu Anda begitu Kjuup.io dapat dipesan.",
  cockpit_upsell_io_planned_price: "Harga yang direncanakan",
  cockpit_upsell_io_cta_request: "Minta informasi",
  kjuup_plus_abo_per_year: "/ tahun",
  kjuup_plus_abo_per_month: "/ bulan",
  kjuup_plus_abo_status_active: "Aktif",
  kjuup_plus_abo_status_requested: "Pembatalan diminta",
  kjuup_plus_abo_status_past_due: "Pembayaran jatuh tempo",
  kjuup_plus_abo_eyebrow: "Kjuup+ · Langganan",
  kjuup_plus_abo_title: "Paket Kjuup+",
  kjuup_plus_abo_seats_free_one: "Tersisa 1 kursi",
  kjuup_plus_abo_billing: "Penagihan",
  kjuup_plus_abo_yearly: "Tahunan",
  kjuup_plus_abo_monthly: "Bulanan",
  kjuup_plus_abo_amount: "Jumlah",
  kjuup_plus_abo_ends: "Berakhir pada",
  kjuup_plus_abo_renews: "Perpanjangan berikutnya",
  kjuup_plus_abo_next_invoice: "Faktur berikutnya",
  kjuup_plus_abo_intro: "Harga perkenalan",
  kjuup_plus_abo_pending_tier: "Mulai perpanjangan berikutnya",
  kjuup_plus_abo_manual: "Kjuup+ aktif untuk perusahaan Anda berdasarkan perjanjian individual.",
  kjuup_plus_abo_invoices: "Faktur",
  kjuup_plus_abo_invoice_paid: "Dibayar",
  kjuup_plus_abo_invoice_view: "Lihat",
  kjuup_plus_abo_invoices_less: "Tampilkan lebih sedikit",
  kjuup_plus_abo_member_hint: "Penagihan dan pembatalan dikelola oleh admin perusahaan Anda.",
  kjuup_plus_abo_withdraw: "Tarik permintaan",
  kjuup_plus_abo_cancel_note: "Alasan (opsional)",
  kjuup_plus_abo_cancel_send: "Minta pembatalan",
  kjuup_plus_abo_cancel: "Batalkan langganan",
  cockpit_upsell_plus_f1: "Kelola aktivitas komunikasi semua karyawan Anda",
  cockpit_upsell_plus_f2: "Beri informasi ke kelompok pengguna tertentu di perusahaan",
  cockpit_upsell_plus_f3: "Simpan chat grup internal",
  cockpit_upsell_plus_when_yearly: "dengan pembayaran tahunan",
  cockpit_upsell_plus_size_small: "1–50 karyawan",
  cockpit_upsell_plus_size_large: "51–200 karyawan",
  cockpit_upsell_plus_title: "Kjuup+ untuk perusahaan",
  cockpit_upsell_plus_text: "Kelola karyawan, izin menulis, dan komunikasi perusahaan di satu tempat. Kanal internal tetap untuk tim Anda, kanal eksternal menghubungkan Anda dengan mitra proyek, dan Anda dapat menjangkau kelompok tertentu secara langsung. Selain Kjuup+, Anda dapat memesan akses Kjuup.io untuk kelompok karyawan. Kjuup+ dan Kjuup.io dapat dikombinasikan.",
  cockpit_upsell_plus_size: "Ukuran perusahaan",
  cockpit_upsell_plus_billing: "Penagihan",
  cockpit_upsell_plus_per_company: "/ perusahaan · bulan belum termasuk PPN",
  cockpit_upsell_plus_onboarding: "Biaya onboarding/pengenalan tergantung ukuran perusahaan",
  cockpit_upsell_plus_larger: "Harga untuk perusahaan lebih besar sesuai permintaan",
  cockpit_upsell_plus_cta: "Tanya tanpa kewajiban",
  cockpit_kpi_deadlines_tasks: "Tenggat & tugas",
  cockpit_kpi_appointments: "Janji temu",
  cockpit_room_admin: "Manajemen proyek & chat",
  cockpit_room_admin_sub: "Semua proyek perusahaan dengan anggota, media, dan chat.",
  pro_todo_not_found: "Tugas ini tidak lagi tersedia.",
  cockpit_chip_overdue: "Terlambat",
  cockpit_chip_today: "Hari ini",
  cockpit_calendar_week: "Minggu {{week}}",
  cockpit_prev_week: "Minggu sebelumnya",
  cockpit_next_week: "Minggu berikutnya",
  cockpit_chip_requested: "Diminta",
  cockpit_todo_due: "Tenggat {{when}}",
  cockpit_todo_at: "{{time}}",
  cockpit_todo_requested_from: "dari {{name}}",
  cockpit_todo_since: "sejak {{when}}",
  cockpit_todo_no_date: "Tanpa tanggal",
  cockpit_todo_mark_done: "Tandai selesai",
  cockpit_my_tasks_title: "Tugas saya",
  cockpit_today_tasks_group: "Tugas hari ini",
  cockpit_assign_none: "Belum ada yang ditugaskan",
  no_project_found: "Proyek tidak ditemukan",
  cockpit_row_more_actions: "Aksi lainnya",
  needs_date: "Tetapkan tanggal",
  cockpit_assign_proposal: "{{name}} dikenali – tetapkan?",
  cockpit_assign_proposal_confirm: "Tetapkan",
  cockpit_assign_proposal_dismiss: "Abaikan",
  cockpit_priority_date: "Tanggal",
  todo_calendar_add: "Tambahkan ke kalender",
  todo_calendar_remove: "Hapus dari kalender",
  cockpit_todo_change_project: "Ubah proyek",
  cockpit_todo_set_date: "Tetapkan tanggal",
  pro_todo_done_confirm: "Yakin ingin menandai tugas ini selesai?",
  cockpit_task_delete_failed: "Tugas tidak dapat dihapus.",
  cockpit_setup_title: "Selesaikan pengaturan",
  cockpit_setup_text: "Tentukan apakah Anda ingin menggunakan chat dan apakah Kjuup.io berfungsi sebagai klien email atau hanya dengan proyek dan laporan harian.",
  cockpit_setup_cta: "Atur sekarang",
  cockpit_group_tasks: "Tenggat & tugas",
  cockpit_group_appointments: "Janji temu",
  cockpit_report_no_activity: "Proyek ini tidak memiliki pesan atau email baru dalam 24 jam terakhir.",
  cockpit_report_room_unavailable: "Proyek ini tidak tersedia.",
  cockpit_report_create_failed: "Laporan harian tidak dapat dibuat.",
  cockpit_report_created: "Laporan harian dibuat",
  addon_enable_confirm: "Aktifkan add-on?",
  addon_enable: "Aktifkan",
  addon_enabled: "Add-on diaktifkan",
  nav_email: "Email",
  nav_my_cockpit: "Kokpit saya",
  nav_news: "Berita",
  nav_recommend: "Rekomendasikan",
  pro_todo_status_done: "Selesai",
  pro_todo_status_open: "Terbuka",
  v2_todo_remove: "Hapus",
  pro_todo_search_people: "Cari orang",
  pro_todo_clear: "Hapus",
  pro_todo_assigned: "(ditugaskan)",
  pro_todo_no_people: "Tidak ada orang ditemukan",
  pro_todo_search_rooms: "Cari proyek",
  pro_todo_no_rooms_match: "Tidak ada proyek yang cocok dengan “{{q}}”",
  pro_todo_no_rooms: "Tidak ada proyek ditemukan",
  pro_todo_activity: "Aktivitas",
  pro_todo_show_less: "Tampilkan lebih sedikit",
  pro_todo_show_all: "Tampilkan semua ({{n}})",
  pro_todo_due: "Tenggat",
  pro_todo_room: "Proyek",
  pro_todo_select_room: "Pilih proyek",
  pro_todo_status: "Status",
  pro_todo_more: "Lainnya",
  pro_todo_edit_title: "Edit tugas",
  pro_todo_description: "Deskripsi",
  pro_todo_created_by: "Dibuat oleh",
  pro_todo_chat: "Chat",
  navigate_to_source: "Buka sumber",
  todo_calendar_connect_title: "Tidak ada kalender terhubung",
  todo_calendar_connect_body_web: "Hubungkan kalender di pengaturan Sinkronisasi Kalender untuk menambahkan ToDo ke dalamnya.",
  todo_calendar_connect: "Hubungkan",
  todo_calendar_removed: "Dihapus dari kalender Anda",
  todo_calendar_added_later: "Ditambahkan. Kalender Anda tidak dapat dijangkau; Kjuup akan mencoba lagi nanti.",
  todo_calendar_added: "Ditambahkan ke kalender Anda",
  todo_calendar_no_date: "Hanya ToDo dengan tanggal yang dapat ditambahkan ke kalender.",
  todo_calendar_failed: "Kalender Anda tidak dapat diperbarui. Silakan coba lagi.",
  todo_calendar_date_title: "Belum ada tanggal",
  todo_calendar_date_save: "Tetapkan tanggal & tambahkan",
  todo_calendar_date_body_web: "Tugas yang ditandai ini belum memiliki tanggal. Tetapkan tanggal untuk menambahkannya ke kalender Anda.",
  kjuup_io_setup_saved: "Pengaturan disimpan",
  kjuup_io_setup_step: "Langkah",
  kjuup_io_setup_chats_title: "Ingin menggunakan chat?",
  kjuup_io_setup_email_title: "Di mana Anda ingin membaca email?",
  kjuup_io_setup_chats_sub: "Chat dengan kolega dan mitra proyek bersifat opsional. Anda dapat menampilkan atau menyembunyikannya di cockpit kapan saja.",
  kjuup_io_setup_email_sub: "Ini hanya memilih apakah Anda memakai klien email di Kjuup atau tetap memakai program email Anda saat ini, seperti Outlook atau lainnya. Anda dapat beralih nanti.",
  kjuup_io_setup_chats_yes: "Ya, tampilkan chat",
  kjuup_io_setup_chats_yes_text: "Pesan berisi chat dan email. Proyek memiliki chat grup untuk semua pihak yang terlibat.",
  kjuup_io_setup_chats_no: "Tidak, bekerja tanpa chat",
  kjuup_io_setup_chats_no_text: "Chat disembunyikan. \"Pesan\" menjadi \"Email\"; proyek, tugas, dan laporan harian tetap ada.",
  kjuup_io_setup_email_client: "Klien email di Kjuup",
  kjuup_io_setup_email_client_text: "Baca dan balas email langsung di Kjuup.",
  kjuup_io_setup_email_reports: "Klien email saat ini",
  kjuup_io_setup_email_reports_text: "Tetap membaca dan membalas di program Anda saat ini, seperti Outlook atau lainnya.",
  kjuup_io_setup_skip: "Nanti",
  next: "Berikutnya",
  kjuup_io_setup_finish: "Selesaikan pengaturan",
  today_label: "hari ini",
  tomorrow_label: "besok",
  cockpit_todo_overdue: "terlambat",
  cockpit_report_management_fazit: "Ringkasan manajemen",
  cockpit_todo_appointment: "Janji temu",
  cockpit_todo_deadline: "Tenggat",
  cockpit_todo_deadline_define: "Tentukan tenggat",
  pro_todo_status_acknowledged: "Dikonfirmasi",
  pro_todo_responsible: "Penanggung jawab",
  pro_todo_notice_confirmed: "Dikonfirmasi di chat",
  pro_todo_notice_sent_at: "Pesan terkirim",
  pro_todo_notice_again: "Kirim pesan lagi",
  pro_todo_notice_send: "Beri tahu melalui pesan Kjuup",
  pro_todo_add_assignee: "Tambah",
  pro_todo_edit: "Edit",
  pro_todo_change_room: "Ubah proyek",
  pro_todo_due_on: "Jatuh tempo pada",
  pro_todo_edit_due: "Edit tenggat",
  pro_todo_no_date: "Tanpa tanggal",
  pro_todo_edit_description: "Edit deskripsi",
  pro_todo_no_description: "Belum ada deskripsi",
  pro_todo_title_label: "Judul",
  pro_todo_title_placeholder: "Masukkan judul...",
  pro_todo_task: "Tugas",
  pro_todo_what: "Apa yang perlu dilakukan?",
  pro_todo_source_email: "Email",
  pro_todo_sources: "Sumber",
  previous: "Sebelumnya",
  kjuup_plus_abo_tier_large: "Kjuup+ Large (hingga {max} karyawan)",
  kjuup_plus_abo_tier_small: "Kjuup+ Small (hingga {max} karyawan)",
  kjuup_plus_abo_status_ends: "Berakhir pada {date}",
  kjuup_plus_abo_seats_over: "Lebih dari {max} karyawan – Kjuup akan menghubungi Anda dengan penawaran khusus.",
  kjuup_plus_abo_seats_next: "Jika ada karyawan baru yang bergabung, paket otomatis beralih ke {next} (dihitung secara proporsional).",
  kjuup_plus_abo_seats_used: "{used} dari {total} kursi terpakai",
  kjuup_plus_abo_seats_free: "Tersisa {count} kursi",
  kjuup_plus_abo_intro_until: "hingga {date}",
  kjuup_plus_abo_invoice_open: "Terbuka · jatuh tempo {date}",
  kjuup_plus_abo_invoices_all: "Tampilkan semua {count}",
  kjuup_plus_abo_requested_hint: "Pembatalan diminta pada {date}. Kjuup mengonfirmasinya di akhir masa berlaku ({end}).",
  kjuup_plus_abo_cancel_hint: "Kjuup meninjau permintaan Anda dan mengonfirmasi pembatalan di akhir masa berlaku ({end}). Hingga saat itu Kjuup+ tetap aktif.",
  kjuup_plus_abo_withdrawn: "Permintaan pembatalan ditarik",
  kjuup_plus_abo_requested: "Pembatalan diminta",
  cockpit_upsell_plus_intro_hint: "{months} bulan pertama, lalu {price}",
  cockpit_upsell_plus_badge: "HARGA PERKENALAN SELAMA {months} BULAN",
  calendar_syncing: "Memperbarui dari kalender…",
  calendar_sync_up_to_date: "Kalender sudah terbaru",
  calendar_sync_failed: "Sinkronisasi gagal",
  delete_multiple_tasks_confirm: "Apakah Anda yakin ingin menghapus {count} ToDo?",
  todos_deleted_count: "{count} ToDo dihapus",
  todos_deleted_partial: "{ok} ToDo dihapus, {fail} gagal",
  todo_unknown: "Tidak diketahui",
  todo_created_from_message: "Tugas dibuat dari pesan ini",
  kjuup_io_todo_calendar_trial_ended_note: "Sinkronisasi kalender · Berlangganan",
  kjuup_io_todo_calendar_nudge: "Sinkronkan ToDo ini ke kalender Anda?",
  kjuup_io_todo_calendar_nudge_cta: "Aktifkan Kjuup.io",
  todo_confirmed: "ToDo dikonfirmasi",
  pro_todo_bulk_delete_title: "Hapus {{n}} tugas?",
  pro_todo_previous_none_own: "Tugas yang terlambat diberikan kepada Anda oleh orang lain dan hanya dapat dihapus oleh mereka.",
  pro_todo_previous_none: "Tidak ada tugas yang terlambat",
  pro_todo_previous_title: "Hapus {{n}} tugas yang terlambat?",
  pro_todo_previous_text: "Semua tugas terbuka Anda dari hari-hari sebelumnya akan dihapus.",
  pro_todo_previous_skipped: "{{n}} yang diberikan oleh orang lain tetap ada.",
  unassign_task_confirm: "Apakah Anda ingin membatalkan penugasan Anda dari tugas ini?",
  unassign_label: "Batalkan",
  pro_todo_delete_title: "Hapus tugas",
  pro_todo_today: "Hari ini",
  pro_todo_yesterday: "Kemarin",
  pro_todo_since_yesterday: "Sejak kemarin",
  pro_todo_mark_open: "Tandai sebagai terbuka",
  verify_completion: "Verifikasi",
  new_label: "Baru",
  bookmarked_no_mylist: "Tugas yang ditandai tidak dapat ditambahkan ke Daftar Saya",
  delete_only_own: "Anda hanya dapat menghapus tugas yang Anda buat sendiri",
  todo_clear_all: "Hapus semua",
  pro_todo_of_completed: "{{done}} dari {{total}} selesai",
  pro_todo_pick_date: "Pilih tanggal",
  pro_todo_show_day: "Tampilkan hari",
  todo_adjust_list: "Sesuaikan daftar",
  pro_todo_section_upcoming: "Mendatang",
  pro_todo_section_done: "Selesai",
  pro_todo_room_empty_today: "Tidak ada tugas hari ini di proyek ini",
  pro_todo_room_empty_day: "Tidak ada tugas pada tanggal ini di proyek ini",
  pro_todo_delete_previous: "Hapus semua",
  todo_my_list_empty: "Hari Anda kosong",
  todo_my_list_empty_hint: "Klik “Sesuaikan daftar” untuk menambahkan tugas",
  pro_todo_empty_title: "Tidak ada apa-apa di sini",
  pro_todo_empty_hint: "Tidak ada tugas yang cocok dengan tampilan ini.",
  pro_todo_selected: "{{n}} dipilih",
  delete_selected_count: "Hapus ({count})",
  pro_todo_adjust_done: "Selesai",
  pro_todo_deleting: "Menghapus...",
  pro_todo_reopen: "Buka kembali tugas",
  pro_todo_step_done: "Selesai",
  move_back_in_progress: "Kembali ke sedang berlangsung",
  pro_todo_mark_not_started: "Tandai belum dimulai",
  back_into_in_progress: "Kembali ke sedang berlangsung",
  pro_todo_mark_in_progress: "Tandai sedang dikerjakan",
  unassign_todo: "Batalkan penugasan ToDo",
  pro_todo_open_room: "Buka proyek",
  pro_todo_new_task: "Tugas baru",
  select_user_back_to_in_progress: "Pilih pengguna yang akan dikembalikan ke sedang berlangsung",
  cockpit_email_accounts_n_many: "{{n}} akun terhubung",
  // Kjuup + Microsoft Teams chats (new-chat pickers, combined groups)
  combined_tab_kjuup: "Kontak Kjuup",
  combined_tab_teams: "Kontak Teams",
  combined_bridge_failed: "Salinan Teams tidak dapat dibuat.",
  combined_chat_label: "Kjuup + Teams",
  combined_guest_tag: "Teams",
  combined_new_group_note: "Kontak Kjuup dan Teams: grup baru dibuat yang juga muncul di Microsoft Teams.",
  teams_new_chat_title: "Chat Teams baru",
  teams_new_chat_topic: "Nama grup (opsional)",
  teams_new_chat_start: "Mulai chat",
  teams_new_chat_creating: "Membuat chat…",
  teams_new_chat_forbidden: "Microsoft Teams tidak mengizinkan chat ini (mis. orang di luar organisasi Anda atau kebijakan IT Anda).",
  teams_new_chat_too_many: "Terlalu banyak orang untuk satu chat.",
  teams_new_chat_type_hint: "Ketik nama untuk mencari di organisasi Anda.",
  teams_new_chat_directory_forbidden: "Organisasi Anda tidak mengizinkan pencarian direktori. Hanya orang dari chat Teams Anda yang ditampilkan.",
  teams_new_chat_account: "Akun",
};
